import { SetupProgress } from '@/shared/components/SetupProgress';
import { useSetupProgress } from '@/shared/hooks/useSetupProgress';

/** Compact setup progress widget for sidebar footer. */
export function SetupProgressCompact() {
  const { milestones, resumeHref } = useSetupProgress();
  return <SetupProgress milestones={milestones} variant="compact" resumeHref={resumeHref} />;
}
